<template>

  <div
    class="person-card column no-wrap">

    <!-- Image -->
    <q-img
      :src="imageLink"
      class="person-card__image no-shrink"/>

    <div
      class="person-card__wrapper">

      <h4
        class="person-card__name q-mb-none">
        {{ $u.localize(name) }}
      </h4>

      <div
        class="person-card__border"
        :style="{backgroundColor: textColor}"/>

      <div
        class="person-card__caption text-small">
        {{ $u.stripTags( $u.localize(caption) ) | truncate(150) }}
      </div>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'person-card',
    props: {
      name: {
        type: [Object, String],
        default: '',
      },
      caption: {
        type: [String, Object],
        default: '',
      },
      textColor: {
        type: String,
        default: '',
      },
      imageLink: {
        type: String,
        default: '',
      },
    },
  };

</script>

<style lang="scss">

  .person-card {
    height: 100%;
    overflow: hidden;
    border-radius: $card-radius;
    background-color: transparentize(#999, .88);

    &__wrapper {
      padding: $spacer-mm $spacer-mm $spacer-md;
    }

    &__image {
      height: 180px;
    }

    &__name {
      height: 49px;
      display: block;
      overflow: hidden;
      font-weight: 700;
      line-height: 1.4em;
      word-spacing: 100vw;
    }

    &__border {
      width: 80%;
      height: 6px;
      margin: 20px 0;
      background-color: white;
    }
  }

</style>
